module.exports = __webpack_public_path__ + "img/shareLink.1197a8de.svg";